import { TwinDictionary } from '../../../../../utils/globals/dictionary'
import { OrderData } from '../types'
import { getSelectedWorkingCenter } from '../../../../../utils/reducers/getters'
import { InputTableLayoutData } from '../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { roundNumberAndDecimals } from '@teinor/erp/prices'
import { totalCalculateParams } from '@teinor/erp/prices/quote/calculate'

type MultiProductsToProcessingTy = {
    products: TwinDictionary[]
}
export interface MultiSelectedTableForProcessingTy {
    forSend: MultiProductsToProcessingTy
}

export const parseRefundSelectedTableForProcessing = (completeData: OrderData) => {
    const parsedData: OrderData = JSON.parse(JSON.stringify(completeData))
    const myTableData = parsedData?.selectedTableData || []
    const result: MultiSelectedTableForProcessingTy = {
        forSend: {
            products: []
        }
    }
    for (const element of myTableData) {
        let myElement = element
        if (parsedData?.dictPosTableData?.[myElement.id] !== undefined) {
            myElement = parsedData?.tableData[parsedData?.dictPosTableData?.[myElement.id]]
        }
        if (!myElement.processed && myElement.OrderId && myElement?.type !== "addButton") {
            const quantity = parseFloat(myElement.quantity)
            if (quantity > 0) {
                result.forSend.products.push({ id: myElement.id, OrderId: myElement.OrderId, quantity: myElement.quantity, returnStock: myElement?.returnStock, unique_number: myElement?.unique_number_selected?.length ? myElement?.unique_number_selected : myElement?.unique_number, WarehouseId: myElement.WarehouseId, quantity2: myElement?.quantity2, calculatedQuantity: myElement.calculatedQuantity })
            }
        }
    }
    return result
}

export const handleRefundData = (tableData: OrderData['tableData']) => {
    const uniquesRefund: TwinDictionary = {}
    const refundedUniques = []
    for (const element of tableData) {
        if (element.refundQuantity) {
            for (const refund of element.refundQuantity) {
                if (refund.unique_number) {
                    for (const unique of refund.unique_number) {
                        refundedUniques.push(unique.serialCode)
                    }
                }
            }
            const restRefundQuantity = roundNumberAndDecimals(parseFloat(element.quantity) - element.quantityRefunded, totalCalculateParams)
            element['restRefundQuantity'] = restRefundQuantity
            element['quantity'] = restRefundQuantity
            element['quantity2'] = roundNumberAndDecimals(restRefundQuantity * element.quantity2base, totalCalculateParams)
            element['totalRefund'] = restRefundQuantity > 0 ? false : true
        } else {
            element['restRefundQuantity'] = element.quantity
            element['totalRefund'] = false 
        }
        if (element.unique_number) {
            for (const myUniques of element.unique_number) {
                if (!refundedUniques.length || !refundedUniques.includes(myUniques.serialCode)) {
                    if (!uniquesRefund?.[element.id]) {
                        uniquesRefund[element.id] = []
                    }
                    uniquesRefund[element.id].push(myUniques)
                }
            }
        }
        element['returnStock'] = true
        element.unique_number = uniquesRefund[element.id]
        element.unique_number_selected = []
        element.WarehouseId = null
        handleRefundDiscounts(element)
    }
    return tableData
}

export const fillRefundHeaderAfter = (element: TwinDictionary) => {
    const workingCenter = getSelectedWorkingCenter()
    return ({
        ...element,
        Customer: element.Customer,
        Supplier: element.Supplier,
        total_subtotalCosts: 0,
        OrderFinancialRows: [],
        WorkingCenterId: workingCenter.id,
        notes: null
    })
}
const handleRefundDiscounts = (element: TwinDictionary) => {
    if (element.extraLineDiscount) {
        const unityLineDiscount = parseFloat(String(element.extraLineDiscount)) / parseFloat(String(element.desiredQuantity))
        element.discount = unityLineDiscount
        element.typeDiscount = 2
    }
    return element
}

export const parseRefundConflicts = (data: OrderData) => {
    let conflicts: TwinDictionary = {}
    for (const element of data.selectedTableData || data.tableData) {
        const myPos = data.dictPosTableData[element.id]
        const myElement = data.tableData[myPos]
        if (myElement.unique_number && (parseFloat(myElement.quantity) !== parseFloat(myElement.restRefundQuantity))) {
            if (!conflicts['unique_numbers']) {
                conflicts['unique_numbers'] = {}
            }
            conflicts['unique_numbers'][element.id] = { name: myElement.name, quantity: myElement.quantity, elements: myElement.unique_number }
        }
    }
    if (data.header.warehouse_conflicts) {
        conflicts['warehouses'] = data.header.warehouse_conflicts
    }
    if (!Object.keys(conflicts)?.length) {
        return null
    }
    return conflicts
}

export const parseSelectedTableDataForRefund = (completeData: InputTableLayoutData) => {
    const parsedData: OrderData = JSON.parse(JSON.stringify(completeData))
    const myTableData = parsedData?.selectedTableData || []
    const result = []
    for (const element of myTableData) {
        let myElement = element
        if (parsedData?.dictPosTableData?.[myElement.id] !== undefined) {
            myElement = parsedData?.tableData[parsedData?.dictPosTableData?.[myElement.id]]
        }
        if (!myElement.processed && myElement.OrderId && myElement?.type !== "addButton") {
            result.push(myElement)
        }
    }
    return result
}
